import { PT } from '~/services/fetch/modules/fallback/hotmart-card-policies/_pt'
import { ES } from '~/services/fetch/modules/fallback/hotmart-card-policies/_es'
import { EN } from '~/services/fetch/modules/fallback/hotmart-card-policies/_en'

export function hotmartCardPoliciesFallback(locale) {
  const RULE_SET = {
    'pt-br': () => PT,
    es: () => ES,
    en: () => EN,
  }

  const RESULT = []

  RESULT.push(RULE_SET[locale]())

  return RESULT
}
